export default __webpack_public_path__ + "static/media/logo-white.aa9490dd.png";